import React, { lazy, Suspense } from "react";

//Librerias
import { Route, Routes } from "react-router-dom";

//Middlewares
// import TimeOut from "./middleware/TimeOut";

//Componentes
import Loader from "./common/components/Loader";
// import Menu from "./containers/Menu";
// import RutaPrivada from "./components/Rutas/RoutePrivate";
import AuthState from "./common/middlewares/Auth";
import RoutesWilson from "./Router/RoutesWilson.routes";

// const Inicio = lazy(() => import("./components/Wilson/Inicio/"));
const Login = lazy(() => import("./Pages/Login"));
// const Perfil = lazy(() => import("./components/Wilson/Perfil/Navegacion"));
// const Servicios = lazy(() => import("./components/Wilson/Servicios"));
// const AdminUsers = lazy(() =>
//   import("./components/Wilson/Administracion/index")
// );
const Verificacion = lazy(() =>
  import("./Pages/Home/Components/CarnetDigital/verificacion")
);

const Router = () => {
  return (
    <>
      <AuthState>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/wilson/*" element={<RoutesWilson />} />
          </Routes>
        </Suspense>
      </AuthState>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route
            path="/carnetdigital/verificacion/:strEmail"
            element={<Verificacion />}
          />
        </Routes>
      </Suspense>
    </>
  );
};

export default Router;
